/**
 * Implementation of the multicodec specification.
 *
 * @module multicodec
 * @example
 * const multicodec = require('multicodec')
 *
 * const prefixedProtobuf = multicodec.addPrefix('protobuf', protobufBuffer)
 * // prefixedProtobuf 0x50...
 *
 */
'use strict';

/** @typedef {import('./generated-types').CodecName} CodecName */
/** @typedef {import('./generated-types').CodecNumber} CodecNumber */
var _defineProperty = require("/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var varint = require('varint');
var intTable = require('./int-table');
var codecNameToCodeVarint = require('./varint-table');
var util = require('./util');
var uint8ArrayConcat = require('uint8arrays/concat');

/**
 * Prefix a buffer with a multicodec-packed.
 *
 * @param {CodecName|Uint8Array} multicodecStrOrCode
 * @param {Uint8Array} data
 * @returns {Uint8Array}
 */
function addPrefix(multicodecStrOrCode, data) {
  var prefix;
  if (multicodecStrOrCode instanceof Uint8Array) {
    prefix = util.varintUint8ArrayEncode(multicodecStrOrCode);
  } else {
    if (codecNameToCodeVarint[multicodecStrOrCode]) {
      prefix = codecNameToCodeVarint[multicodecStrOrCode];
    } else {
      throw new Error('multicodec not recognized');
    }
  }
  return uint8ArrayConcat([prefix, data], prefix.length + data.length);
}

/**
 * Decapsulate the multicodec-packed prefix from the data.
 *
 * @param {Uint8Array} data
 * @returns {Uint8Array}
 */
function rmPrefix(data) {
  varint.decode(data);
  return data.slice(varint.decode.bytes);
}

/**
 * Get the codec of the prefixed data.
 *
 * @param {Uint8Array} prefixedData
 * @returns {CodecName}
 */
function getCodec(prefixedData) {
  var code = varint.decode(prefixedData);
  var codecName = intTable.get(code);
  if (codecName === undefined) {
    throw new Error("Code ".concat(code, " not found"));
  }
  return codecName;
}

/**
 * Get the name of the codec.
 *
 * @param {CodecNumber} codec
 * @returns {CodecName|undefined}
 */
function getName(codec) {
  return intTable.get(codec);
}

/**
 * Get the code of the codec
 *
 * @param {CodecName} name
 * @returns {CodecNumber}
 */
function getNumber(name) {
  var code = codecNameToCodeVarint[name];
  if (code === undefined) {
    throw new Error('Codec `' + name + '` not found');
  }
  return varint.decode(code);
}

/**
 * Get the code of the prefixed data.
 *
 * @param {Uint8Array} prefixedData
 * @returns {CodecNumber}
 */
function getCode(prefixedData) {
  return varint.decode(prefixedData);
}

/**
 * Get the code as varint of a codec name.
 *
 * @param {CodecName} codecName
 * @returns {Uint8Array}
 */
function getCodeVarint(codecName) {
  var code = codecNameToCodeVarint[codecName];
  if (code === undefined) {
    throw new Error('Codec `' + codecName + '` not found');
  }
  return code;
}

/**
 * Get the varint of a code.
 *
 * @param {CodecNumber} code
 * @returns {Array.<number>}
 */
function getVarint(code) {
  return varint.encode(code);
}

// Make the constants top-level constants
var constants = require('./constants');

// Human friendly names for printing, e.g. in error messages
var print = require('./print');
module.exports = _objectSpread({
  addPrefix: addPrefix,
  rmPrefix: rmPrefix,
  getCodec: getCodec,
  getName: getName,
  getNumber: getNumber,
  getCode: getCode,
  getCodeVarint: getCodeVarint,
  getVarint: getVarint,
  print: print
}, constants);